<template>
  <StatisticsHeader>
    <StatisticsPanel :load="load" v-slot="{ data }">
      <InvoicesStats :data="data" />
    </StatisticsPanel>
  </StatisticsHeader>
</template>

<script>
import StatisticsHeader from "@/statistics/components/StatisticsHeader.vue";
import StatisticsPanel from "@/statistics/components/StatisticsPanel.vue";
import InvoicesStats from "@/statistics/components/stats/InvoicesStats.vue";
import {StatisticsController} from "@/statistics/controllers/StatisticsController";

export default {
  name: 'StatisticsInvoicesView',
  components: {StatisticsHeader, StatisticsPanel, InvoicesStats},
  methods: {
    load: urlParams => StatisticsController.getInvoices(urlParams),
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color: THEME_COLOR_PRIMARY
  span
    color: THEME_COLOR_PRIMARY_FADDED
</style>
